import React from 'react';
import FlashMessage from './FlashMessage.react';
import FlashMessageStore from '../../stores/FlashMessageStore.js';

class FlashMessageContainer extends React.Component {
	state = {
	  flashMessage: FlashMessageStore.getLast(),
	};

	componentDidMount() {
	  FlashMessageStore.addChangeListener(this._onChange);
	}

	componentWillUnmount() {
	  FlashMessageStore.removeChangeListener(this._onChange);
	}

	render() {
	  if (
	    Object.keys(this.state.flashMessage).length === 0 &&
	    this.state.flashMessage.constructor === Object
	  ) {
	    return <div />;
	  }

	  let containerClass = 'flashMessages-container';
	  if (typeof this.state.flashMessage.options !== 'undefined'
	    && typeof this.state.flashMessage.options.parentClass !== 'undefined')
	  {
	    containerClass = this.state.flashMessage.options.parentClass;
	  }

	  return (
	    <div className={containerClass}>
	      <FlashMessage key={this.state.flashMessage.id} {...this.state.flashMessage} />
	    </div>
	  );
	}

	_onChange = () => {
	  this.setState({ flashMessage: FlashMessageStore.getLast() });
	};
}

module.exports = FlashMessageContainer;
